import _ from 'underscore';
import { CalloutEntity } from './callout-entity';

export const sortListWithPriority = (list, newItem) => {
  if (newItem) {
    const newList = [...list, newItem];
    return _.sortBy(newList, item => item.priority);
  }
  return _.sortBy(list, item => item.priority);
};

export const getCalloutList = (calloutList) => {
  const newQueue = [];
  calloutList.forEach((item) => {
    const calloutEntity = new CalloutEntity(item);
    newQueue.push(calloutEntity);
  });

  const sortedQueue = sortListWithPriority(newQueue);
  return sortedQueue;
};
